module.exports = __webpack_public_path__ + "static/art1-90876c22180be1d9a0c22d4b4d902358.png";